import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stacked" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, {
      modelValue: $data.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active) = $event)),
      class: "tabs",
      tabs: $options.tabs
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    ($data.active === 'ingest')
      ? (_openBlock(), _createBlock(_component_SettingsFrame, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode($setup["Ingest"])
          ]),
          _: 1 /* STABLE */
        }))
      : ($data.active === 'ingest-acl')
        ? (_openBlock(), _createBlock(_component_SettingsFrame, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode($setup["IngestACL"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
  ]))
}